import React from 'react';
import clsx from 'clsx';
import SocialIconButton, { PLATFORM_CONFIG } from './SocialIconButton.jsx';

const SIZE_CLASSES = {
  sm: 'gap-2',
  md: 'gap-3',
  lg: 'gap-4',
};

const LABEL_CLASSES = {
  default: 'text-slate-700',
  muted: 'text-slate-500',
  footer: 'text-[var(--primary-foreground,#FFFFFF)]',
};

function isValidUrl(url) {
  try {
    const parsed = new URL(String(url || ''));
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}

function normalizePlatform(platform) {
  const normalized = String(platform || '').trim().toLowerCase();
  return normalized === 'twitter' ? 'x' : normalized;
}

export default function SocialMediaIcons({
  links = [],
  size = 'md',
  variant = 'default',
  showLabels = false,
  labelPrefix = 'Visit us on',
}) {
  const visibleLinks = (Array.isArray(links) ? links : [])
    .map((link) => ({
      ...link,
      platform: normalizePlatform(link?.platform),
    }))
    .filter((link) => link?.isEnabled !== false && isValidUrl(link?.url) && PLATFORM_CONFIG[link.platform])
    .sort((a, b) => Number(a.sortOrder || 0) - Number(b.sortOrder || 0));

  if (visibleLinks.length === 0) {
    return null;
  }

  return (
    <div className={clsx('flex flex-wrap items-center', SIZE_CLASSES[size] || SIZE_CLASSES.md)}>
      {visibleLinks.map((link) => {
        const config = PLATFORM_CONFIG[link.platform];
        const label = link.label || config.label;
        return (
          <div key={`${link.platform}-${link.url}`} className="flex items-center gap-2">
            <SocialIconButton
              platform={link.platform}
              href={link.url}
              size={size === 'lg' ? 18 : 16}
              ariaLabel={`${labelPrefix} ${label}`}
            />
            {showLabels ? (
              <span className={clsx('text-sm font-medium', LABEL_CLASSES[variant] || LABEL_CLASSES.default)}>
                {label}
              </span>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
